import { deliveryDrawer } from '../snippets/delivery-drawer';
import { drawerStoreLocater } from '../snippets/drawer-store-locater';

const Header = {
  headerRoot: null,
  headerContainer: null,
  cartCTA: null,
  mobileMenuOpenCTA: null,
  cartCountEl: null,
  locaterDrawer: null,

  initiliaseElement() {
    this.headerRoot = document?.querySelector('.js-header');
    this.headerContainer = this.headerRoot?.querySelector(
      '.js-header-container',
    );
    this.cartCTA = this.headerContainer?.querySelector('.js-header-cart-cta');
    this.mobileMenuOpenCTA = this.headerContainer?.querySelector(
      '.js-mobile-menu-cta',
    );
    this.cartCountEl = this.cartCTA?.querySelector('.js-cart-count');
    this.locaterDrawer = this.headerRoot.querySelector(
      '.js-open-locater-drawer',
    );
  },

  initializeEvents() {
    this.initiliaseElement();

    if (this.cartCTA != null) {
      this.cartCTA.addEventListener('click', (e) => {
        e.preventDefault();
        this.openCart();
      });
    }

    if (this.locaterDrawer != null) {
      this.locaterDrawer.addEventListener('click', (e) => {
        e.preventDefault();
        deliveryDrawer.openDeliveryOverlay();
        drawerStoreLocater.resetDrawerState();
      });
    }

    // NEW: Listen for cart updates
    document.addEventListener('cart:updated', (e) => {
      const count = e.detail?.itemCount ?? 0;
      this.updateCartCountUI(count);
    });
  },

  updateCartCountUI(count) {
    if (this.cartCountEl) {
      this.cartCountEl.textContent = count > 9 ? `9+` : count;
      this.cartCountEl.classList.toggle('hidden', count === 0);
    }
  },

  openCart() {
    const drawerEvent = new CustomEvent('open-drawer', {
      detail: { drawerName: 'cart-drawer' },
    });
    window.dispatchEvent(drawerEvent);
  },
};

export default Header;
